import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, merge, of, switchMap} from 'rxjs';
import {EVENT_BUS} from '../../../../../shared/domain/tokens/event-bus.token';
import {BookingLockCheckedEvent} from "../../../../../shared/application/events/booking/booking-lock-checked.event";
import {CreateAccountUseCase} from "../use-cases/create-account.usecase";
import {
  AccountEntriesRejectedEvent
} from "../../../../../shared/application/events/account/account-entries-rejected.event";
import {
  BookingActivationStartedEvent
} from "../../../../../shared/application/events/booking/booking-activation-started.event";
import {AccountStoreService} from "../services/account-store.service";

@Injectable()
export class DeactivateAccountSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly createAccountUseCase = inject(CreateAccountUseCase);
  private readonly accountStoreService = inject(AccountStoreService);

  constructor() {
    merge(
      this.eventBus.ofType(AccountEntriesRejectedEvent),
      this.eventBus.ofType(BookingActivationStartedEvent),
      this.eventBus.ofType(BookingLockCheckedEvent).pipe(filter(({payload}) => payload.isLocked))
    )
      .pipe(
        switchMap((event) => {
          if (event instanceof BookingActivationStartedEvent) {
            this.accountStoreService.clearSelectedAccount();

            return of(null)
          }

          return this.createAccountUseCase.execute()
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
